export default __webpack_public_path__ + "static/media/pen.e69223b7.svg";